import React from "react";
import {connect} from "react-redux";
import {
    Animated,
    Dimensions,
    FlatList, Image,
    Keyboard,
    ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";

import AvatarIcon from "../Header/AvatarIcon";
import MailPicto from "../Picto/MailPicto";
import ConfidentialPicto from "../Picto/ConfidentialPicto";

import { getAllTheme, } from "../../API/API";

import FocusCerclePicto from "../Picto/FocusCerclePicto";
import MyTheme from "../../Theme/Theme";
import Tabs from "../Menu/Tabs";

import FocusActiveCerclePicto from "../Picto/FocusActiveCerclePicto";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {wrapAction, wrapStyle} from "../../sw/helpers";

import ContactProfile from "../POIProfile/ContactProfile"
import ThemeProfile from "../POIProfile/ThemeProfile"
import EntityProfile from "../POIProfile/EntityProfile"

// import NotifActivePicto from "../Picto/NotificationActiverActivePicto";
// import NotifPicto from "../Picto/NotificationActiverPicto";
import NotifActivePicto from "../Picto/NotificationActiverActiveCerclePicto";
import NotifPicto from "../Picto/NotificationActiverCerclePicto";

import tinycolor from "tinycolor2";


const getStyleSheet = (theme, {height, width}) => {
  const { colors, fonts } = theme;

  return StyleSheet.create({
      container:{
      },
      headerContainer:{
          backgroundColor: colors.primary.White.value,
          borderBottomLeftRadius:10,
          borderBottomRightRadius:10,
          marginBottom:15,
          position:"relative",
          zIndex:3,
          width: width,
          maxHeight:230,

      },
      avatarButtonContainer:{
          flexDirection:"row",
          marginTop:25,
          marginBottom:20,
          marginHorizontal:20,
          justifyContent:"space-between",
          alignItems:"center"
      },
      topButtonContainer: wrapStyle({
          flexDirection:"row",
          justifyContent:"space-between",
          alignItems:"center"
      }),
      topButton:{
          marginHorizontal:5,
          width:50
      },
      textContainer:{
          flexShrink: 1,
          marginHorizontal:20
      },
      nomText:{
          fontFamily: fonts.title,
          fontWeigth:600,
          fontSize:15,
          marginBottom:5,
          color: colors.tertiary.black1.value,
      },
      descriptionText:{
          fontFamily: fonts.text,
          fontSize:14,
          marginBottom:10,
          color: colors.tertiary.black1.value,
      },
      affiliationWrapper: {
        marginBottom: 5
      },
      affiliationText: {
        textAlign: "center",
        borderRadius: 5,
        fontWeight: "bold",
        fontFamily: fonts.text,
        fontSize: 12,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 2,
        paddingBottom: 2,
        marginRight: 5,
      },
      mailContainer:{
          flexDirection:"row",
          alignItems:"center",
          marginHorizontal:20
      },
      textMail : {
          color: colors.primary.blue1.value,
          fontSize:15,
          fontFamily: fonts.text,
      },
      botButtonContainer:{
          flexDirection:"row",
          alignItems:"center",
          justifyContent:"space-between",
          marginHorizontal:20
      },
      separator:{
          width:"95%",
          borderRadius:50,
          height:26,
          backgroundColor: colors.primary.blue1.value,

      },
      feedContainer:{
          marginTop:20,
          height: height-380
      },
      SousTitre : {
          fontFamily : fonts.text,
          color: colors.tertiary.black1.value,
          fontWeight:"600",
          fontSize:15,
          marginBottom:10
      }
  });
}


class POIScreen extends React.Component{
    constructor(props) {
        super(props);

        this.render_header = this.render_header.bind(this);

        this.setFocus = this.setFocus.bind(this);
        this.setNotification = this.setNotification.bind(this);
        this.newPOI = this.newPOI.bind(this);

        this.scrollViewRef = React.createRef();
        this.mref = React.createRef();
        this.scrollViewTabRef = React.createRef();
        this.tabsRef = React.createRef();

        this.setActiveTab = this.setActiveTab.bind(this);
        this.onItemPress = this.onItemPress.bind(this);
        this.onFlatListScroll = this.onFlatListScroll.bind(this);

        this._loadAllThemes();
        this.init();
    }

    init() {
      const {id, type} = this.props.route.params;
      const poi_state = this.newPOI(id, type)

      this.state = {...poi_state, all_themes: []}
    }

    componentDidUpdate() {
      const {id, type} = this.props.route.params;
      const {id: current_id, type: current_type} = this.state

      if (current_id != id || current_type != type) {
        this.setState(this.newPOI(id, type));
      }
    }

    newPOI(id, type) {
      const component_class = {
        'contact': ContactProfile,
        'entity': EntityProfile,
        'theme': ThemeProfile,
      }[type];

      const component = new component_class();

      component.load(id).then(({item, focus_enabled, notification_enabled}) => {
        this.setState({ item, focus_enabled, notification_enabled })

        this._setHeader(component.getInfo(item));

	// FIXME : all_themes may not be loaded yet!!!
        const tab_props = {...this.props, item, type, all_themes: this.state.all_themes};

        const tabs = component.getTab(tab_props).map((x, i) => {
          // key and ref are used by tabs
          return {...x, key: i, ref: React.createRef()}
        });
        this.setState({ tabs });
      })

      // load current entity and reset fields that depends on it
      return {
        id: id,
        type: type,
        // item related
        component: component,
        item: null,
        focus_enabled: false,
        notification_enabled: false,
        tabs: [],
        // tab related
        activeTab : 0,
        scrollX: new Animated.Value(0),
      }
    }

    getDimensions() {
        return Dimensions.get('window');
    }

    _setHeader({ title }){
      const { theme } = this.props;
      const styleHeaderGlobal = {
        shadowOpacity: 0,
        shadowRadius: 0,
        borderWidth:0,
        elevation: 0,
        borderColor:"transparent" ,
        borderBottomWidth:0,
        backgroundColor : theme.colors.tertiary.grey3.value,
        height:80
      };

      this.props.navigation.setOptions({
        headerTitle: title,
        title: title,
        headerRight: "",
        headerTitleStyle: {fontFamily: theme.fonts.title},
        headerStyle: styleHeaderGlobal,
        headerLeft: () => {
          return <TouchableOpacity onPress={this.props.navigation.goBack}>
              <Image resizeMode={"contain"} style={{width:20,marginLeft:10,height: 20, flex: 1}}
                     source={theme.pictos.chevronGaucheMediumPicto.light} />
          </TouchableOpacity>
        }
      });
    }

    _loadAllThemes() {
      return getAllTheme().then(all_themes => {
        this.setState({ all_themes })
      })
    }

    setFocus(){
      this.state.component.setFocus(this.state.item, this.state.focus_enabled)
      .then(focus_enabled => {
        this.setState({focus_enabled})
      })
    }

    setNotification(){
      this.state.component.setNotification(this.state.item, this.state.notification_enabled)
      .then(notification_enabled => {
        this.setState({notification_enabled})
      })
    }

    getInfo() {
      return this.state.component.getInfo(this.state.item);
    }

    renderAffiliations(affiliations, styles) {
      return <ScrollView style={styles.affiliationWrapper} horizontal={true}>
	{affiliations.map(({name, color}, i) => {
	  const tcolor = tinycolor(color);
	  const style = {color: tcolor.clone().darken(30), backgroundColor: tcolor.clone().brighten(40)}
	  return <Text key={i} style={[styles.affiliationText, style]}>{ name }</Text>
	})}
      </ScrollView>
    }

    render_header(styles){
        let { title, subtitle, description, affiliations } = this.getInfo();

        const is_theme = this.state.type === "theme";

        const lineNumbers = affiliations.length ? 3 : 2;

        const info = <View style={styles.textContainer}>
	  <View style={{flexDirection: "row"}}>
	    <Text style={styles.nomText}>{title}</Text>
	    { is_theme && this.state.item.confidential && <ConfidentialPicto style={{width: 21, height: 21}} isHeader={true}/> }
	  </View>
          {!!subtitle && <Text style={styles.SousTitre}>{subtitle}</Text>}
          { !!affiliations.length && this.renderAffiliations(affiliations, styles) }
          { /* no richtext for small header (also numberOfLines would not work) */ }
          {!!description && <Text style={styles.descriptionText} numberOfLines={lineNumbers}>
            {description}
          </Text>}
        </View>

        return (
            <View>
                <View style={styles.headerContainer}>
                    <View style={styles.avatarButtonContainer}>
                        { is_theme ? info
                          : <AvatarIcon icon={ this.state.item.img} style={{width:60, height:60,borderRadius:24}} /> }
                        <View style={styles.topButtonContainer}>
                            <TouchableOpacity onPress={wrapAction(this.setNotification)}>
                                {
                                  this.state.notification_enabled
                                  ? <NotifActivePicto  style={styles.topButton} isHeader={true}/>
                                  : <NotifPicto  style={styles.topButton} isHeader={true}/>
                                }
                            </TouchableOpacity>
                            <TouchableOpacity onPress={wrapAction(this.setFocus)}>
                                {
                                  this.state.focus_enabled
                                  ? <FocusActiveCerclePicto  style={styles.topButton} isHeader={true}/>
                                  : <FocusCerclePicto  style={styles.topButton} isHeader={true}/>
                                }
                            </TouchableOpacity>
                        </View>
                    </View>
                    { !is_theme && info }
                    {/*           <View style={styles.mailContainer}>
                        <MailPicto isHeader={true} style={{width:15,marginRight:5}} />
                        <Text style={styles.textMail}>{this.props.auth.compte.email}</Text>
                    </View>*/}
                </View>
                <View style={{width:'100%',justifyContent:"center",alignItems:"center",position:"absolute",bottom:3,zIndex:2}}>
                    <View style={styles.separator}></View>
                </View>
            </View>)
    }

    onFlatListScroll() {
      // update scrollX, notify the tab menu to move too
      return Animated.event([{
          nativeEvent: { contentOffset: {x: this.state.scrollX} }
        }], {
          listener: () => { this.setActiveTab() },
          useNativeDriver:false
        }
      )
    }

    onItemPress(itemIndex) {
        const { width } = this.getDimensions();

        Keyboard.dismiss();
        // horizontal content flat list, scroll to offset
        this.mref.current.scrollToOffset({
            offset : itemIndex * width,
            // animated: true
        });
    }

    setActiveTab(){
      const { width } = this.getDimensions();
      // each tab is width long (screen width)
      let activeTab = Math.round(this.state.scrollX._value/width);

      // console.log("(activeTab-1) * (width/4)",(activeTab-1) * (width/4));
      // Make the tab itself scroll
      this.scrollViewTabRef.current.scrollTo({
        x: (activeTab-1) * (width/4),
        y: 0,
        animated:true
      });

      Keyboard.dismiss();

      // we cant detect end of scroll w/ horizontal...
      // So we detect it ourselves checking every X ms
      this.x && clearTimeout(this.x);
      this.x = setTimeout(() => {
        // we dont setState to not interfere w/ the animation
        // warning: will prev_activetab always be called?
        const prev_activetab = this.prev_activetab || this.state.activeTab;

        // wont be called at all w/ timeout? scrollX would have changed
        // if (prev_scrollx === this.state.scrollX._value) {
        if (prev_activetab !== activeTab) {
          this.prev_activetab = activeTab;
          this.setState({ activeTab })
        }
      }, 100)
    }


    render() {
        const {width, height} = this.getDimensions();
        const {type, id, tabs, item, scrollX, activeTab} = this.state;

        const styles = getStyleSheet(this.props.theme, { width, height })

        const renderTabOfPOI = ({item, index}) => {
          const content = typeof(item.content) == "function" ? item.content() : item.content;

          return <View style={[{height :(index==activeTab)? "unset":height-252, width: width}]}>
            { content }
          </View>
        }

        return <ScrollView key={type +'-'+ id} ref={this.scrollViewRef} style={{flex:1, flexDirection:"column"}}>

            {item && this.render_header(styles)}

            { /* small tab switcher */ }
            <ScrollView ref={this.scrollViewTabRef} horizontal={true} showsHorizontalScrollIndicator={false} style={{paddingLeft: 20, width: width, height: 40, flexGrow: 0}}>
                <Tabs scroll={true} scrollX={scrollX} isExplorer={true} data={tabs} total_width={width}
                      indexActive={activeTab} onItemPressCallBack={this.setActiveTab} onItemPress={this.onItemPress}/>
            </ScrollView>

            <FlatList
                data={tabs}
                renderItem={renderTabOfPOI}
                ref={this.mref}
                style={{flex:1}}
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                pagingEnabled={true}
                bounces={false}
                stickyHeaderIndices={[0]}
                onScroll={this.onFlatListScroll()}
            />

        </ScrollView>;
    }
}





const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}


export default compose(withTranslation(),connect(mapStateToProps))(POIScreen);


